"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RunScheduledPresetsNowResultDto = exports.UserNotificationTriggerDiagnosisDto = exports.NotificationTriggerDiagnosisDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class NotificationTriggerDiagnosisDto {}
exports.NotificationTriggerDiagnosisDto = NotificationTriggerDiagnosisDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationPresetTrigger
}), __metadata("design:type", String)], NotificationTriggerDiagnosisDto.prototype, "trigger", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationTriggerDiagnosisResult
}), __metadata("design:type", String)], NotificationTriggerDiagnosisDto.prototype, "result", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [String]
}), __metadata("design:type", Array)], NotificationTriggerDiagnosisDto.prototype, "reasons", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: 'object'
}), __metadata("design:type", Object)], NotificationTriggerDiagnosisDto.prototype, "details", void 0);
class UserNotificationTriggerDiagnosisDto {}
exports.UserNotificationTriggerDiagnosisDto = UserNotificationTriggerDiagnosisDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserNotificationTriggerDiagnosisDto.prototype, "userPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserNotificationTriggerDiagnosisDto.prototype, "evaluatedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [NotificationTriggerDiagnosisDto]
}), __metadata("design:type", Array)], UserNotificationTriggerDiagnosisDto.prototype, "triggers", void 0);
class RunScheduledPresetsNowResultDto {}
exports.RunScheduledPresetsNowResultDto = RunScheduledPresetsNowResultDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], RunScheduledPresetsNowResultDto.prototype, "total", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: 'object'
}), __metadata("design:type", Object)], RunScheduledPresetsNowResultDto.prototype, "byTrigger", void 0);
//# sourceMappingURL=NotificationTriggerDiagnosis.dto.js.map